import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as VatReturnListService from '../../../services/api/vatreturn_list';
import * as ApplicantService from '../../../services/api/applicant';
import { getSchemeTypes } from '../../../services/api/register';
import ModalActions from '../../../redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
import { ReducerKeys } from '../index';
import { showToastAction } from '../../../components/atoms/toast_message';

/** Fetch VatReturn List  */

interface VatReturnListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  period?: string;
  year?: string;
  declaration_status?: string;
  vat_return_state?: string;
}

class FetchVatReturnList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VATRETURN_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VATRETURN_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VATRETURN_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: VatReturnListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchVatReturnList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchVatReturnList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchVatReturnListAll implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VATRETURN_LIST_ALL,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VATRETURN_LIST_ALL,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VATRETURN_LIST_ALL,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchVatReturnListAll();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchVatReturnList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

//Fetch types
class FetchSchemeTypes implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_SCHEME_TYPES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_SCHEME_TYPES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_SCHEME_TYPES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getSchemeTypes();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch Scheme Types Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//Fetch quarters
class FetchQuarters implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_QUARTER_TYPES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_QUARTER_TYPES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_QUARTER_TYPES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchQuarters();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch Quarter Types Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMonthQuarters implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MONTH_QUARTER_TYPES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MONTH_QUARTER_TYPES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MONTH_QUARTER_TYPES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchMonthQuarters();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch Month Quarter Types Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//Add Vat Return

class AddVatReturn implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.ADD_VATRETURN,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.ADD_VATRETURN,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.ADD_VATRETURN,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: VatReturnListService.IAddVatReturn): any {
    return async (dispatch: Dispatch<any>, getState: any) => {
      try {
        if (
          (payload.start_date || payload.end_date) &&
          !hasSelectedPeriodEnded(getState, payload.quarter, payload.year)
        ) {
          showToastAction(
            dispatch,
            'The selected period has not ended yet.',
            'error'
          );
          dispatch(this.onFailed());
          return;
        }

        dispatch(this.onPending());
        let response = await VatReturnListService.addVatReturn(payload);
        dispatch(this.onSuccess(response.data));
        dispatch(
          new FetchVatReturnList().action({
            sortField: 'vat_return_id',
            page: 0,
            pageSize: 10,
            order: 'desc',
          })
        );
        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_ADD_VAT_RETURN,
          })
        );
      } catch (error: any) {
        // console.log('AddVatReturn Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

const hasSelectedPeriodEnded = (
  getState: any,
  quarterId: number,
  year: number
) => {
  const state = getState()[ReducerKeys.VATRETURN_LIST_REDUCER];
  const periods = [
    ...(state.quarterList.data ?? []),
    ...(state.monthQuarterList.data ?? []),
  ];
  const selectedPeriod = periods.find(
    (period: { quarter_id: number }) => period.quarter_id === Number(quarterId)
  );

  if (!selectedPeriod) return true;

  const periodEndDate = new Date(
    Number(year),
    selectedPeriod.ending_month,
    0,
    23,
    59,
    59,
    999
  );

  return new Date() > periodEndDate;
};

//Fetch active registrations of user
interface IFetchUserInfoPayload {
  applicant_id?: string;
}
class FetchUserInfo implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_USER_INFO_VAT_RETURN_CREATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_USER_INFO_VAT_RETURN_CREATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_USER_INFO_VAT_RETURN_CREATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchUserInfoPayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ApplicantService.fetchApplicantActiveRegistrations(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchUserInfo Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//Add Vat Return
interface IAddVatReturnPayment {
  amount: number;
  payment_date: Date;
  vat_return_id: string;
  onSuccess?: () => void;
  onError?: () => void;
}
class AddVatReturnPayment implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.ADD_VAT_RETURN_PAYMENT,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.ADD_VAT_RETURN_PAYMENT,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.ADD_VAT_RETURN_PAYMENT,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IAddVatReturnPayment): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.addVatReturnPayment(payload);
        if (payload.onSuccess) payload.onSuccess();
        dispatch(this.onSuccess(response.data));
        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_ADD_VAT_RETURN_PAYMENT,
          })
        );
      } catch (error: any) {
        // console.log('AddVatReturnPayment Error:', error.message);
        if (payload.onError) payload.onError();
        dispatch(this.onFailed());
      }
    };
  }
}

class SetAgentTraders implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_AGENT_TRADERS,
      status: StateStatus.Pending,
      data: [],
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_AGENT_TRADERS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_AGENT_TRADERS,
      status: StateStatus.Failed,
      data: [],
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await VatReturnListService.fetchAgentTraders();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Agent Traders Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchVatReturnListAction: (payload: VatReturnListInput) =>
    new FetchVatReturnList().action(payload),
  fetchVatReturnListAllAction: () => new FetchVatReturnListAll().action(),
  fetchSchemeTypesAction: () => new FetchSchemeTypes().action(),
  fetchQuartersAction: () => new FetchQuarters().action(),
  fetchMonthQuarters: () => new FetchMonthQuarters().action(),
  addVatReturnAction: (payload: VatReturnListService.IAddVatReturn) =>
    new AddVatReturn().action(payload),
  fetchUserInfoAction: (payload: IFetchUserInfoPayload) =>
    new FetchUserInfo().action(payload),
  addVatReturnPaymentAction: (payload: IAddVatReturnPayment) =>
    new AddVatReturnPayment().action(payload),
  fetchAgentTradersAction: () => new SetAgentTraders().action(),
};
